import { useState } from "react";

import {
  ModalContentPhoneNumberEnterCode,
  ModalContentPhoneNumberRequestCode,
  ModalContentPhoneNumberSuccess,
  useAuth,
} from "~components";
import { msg } from "~utils";

type ModalContentStep = "request-code" | "enter-code" | "success";

type ModalContentPhoneNumberEditProps = {
  isPhoneNumberVerified?: boolean;
  onDismiss: (data?: string | null | undefined | number, role?: string) => void;
  phoneNumber?: string;
  step?: ModalContentStep;
};

export function ModalContentPhoneNumberEdit(props: ModalContentPhoneNumberEditProps) {
  const { isPhoneNumberVerified = false, onDismiss, step, phoneNumber } = props;
  const { refreshUser } = useAuth();
  const [_step, _setStep] = useState<ModalContentStep>(step ?? "request-code");
  const [_phoneNumber, _setPhoneNumber] = useState<string>(phoneNumber ?? "");

  const TITLE = isPhoneNumberVerified
    ? msg("PROFILE_PHONE_NUMBER_UPDATE_TITLE")
    : msg("PROFILE_PHONE_NUMBER_VERIFY_TITLE");

  const handleSuccess = async () => {
    // Using refreshUser to trigger a refetch of user data to
    // keep the `userInfo` in AuthProvider's context updated.
    refreshUser();
    onDismiss();
  };

  switch (_step) {
    case "request-code":
      return (
        <ModalContentPhoneNumberRequestCode
          isPhoneNumberVerified={isPhoneNumberVerified}
          phoneNumber={_phoneNumber}
          originalPhoneNumber={phoneNumber ?? ""}
          onDismiss={onDismiss}
          title={TITLE}
          onStepChange={() => _setStep("enter-code")}
          onPhoneNumberChange={_setPhoneNumber}
        />
      );
    case "enter-code":
      return (
        <ModalContentPhoneNumberEnterCode
          onDismiss={onDismiss}
          title={TITLE}
          onStepChange={() => _setStep("success")}
          phoneNumber={_phoneNumber}
        />
      );
    case "success":
      return <ModalContentPhoneNumberSuccess onDismiss={handleSuccess} title={TITLE} />;
    default:
      throw new Error(msg("PROFILE_PHONE_NUMBER_STEP_ERROR_MESSAGE", _step));
  }
}
